import React from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";

function Revolutionindustries(props) {
  return (
    <section className="tekgrip_section tekrevol_gray_bg  p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={10} lg={10} xl={10} xxl={12}>
            <div className="example" data-text="Revolutionizing">
              <h2>
                Our Global Impact in Revolutionizing Digital Healthcare
                Solutions
              </h2>
            </div>
            <p className="main_para">
              Our commitment to the digitization of the healthcare industry has
              led us to create a massive impact at a global level. With a
              presence in multiple regions, including USA, UK, Canada, and GCC,
              we dedicate our services to making healthcare accessible and
              convenient for patients everywhere. Join the digital healthcare
              revolution with TekRevol and experience a new era of healthcare
              solutions!
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekgrip_tabs"
          >
            <Tab.Container defaultActiveKey="0">
              <Row>
                <Col xs={12} md={6} lg={6} xl={6}>
                  <Nav variant="pills" className="flex-column">
                    <Nav.Item>
                      <Nav.Link eventKey="0">
                        Digital Healthcare in the UK
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="1">
                        Digital Healthcare in Canada
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="2">
                        Digital Healthcare in GCC
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
                <Col xs={12} md={6} lg={6} xl={6} className="my-auto">
                  <Tab.Content>
                    <Tab.Pane eventKey="0">
                      <p>
                        Our digital healthcare solutions in the UK are aligned
                        in a way to enhance the overall structure of the
                        healthcare sector. For that purpose, we employ modern
                        strategies and updated technologies to create
                        personalized patient care.
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="1">
                      <p>
                        Our innovative healthcare digital solutions in Canada
                        are changing how healthcare is catered. With the optimal
                        utilization of technologies, we aim to provide patients
                        with access to healthcare services with complete control
                        of their health.
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="2">
                      <p>
                        We lead the advancements of digital healthcare solutions
                        in the GCC region through our advanced practices to
                        increase accessibility for patients. We are leveraging
                        the tremendous growth of the healthcare industry in this
                        region to bring an impactful change.
                      </p>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Revolutionindustries;
